import React, { useState } from "react";
import Input from "../../atoms/Input/Input";
import useRequest from "../../../context/useRequest";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const CouponForm = ({ setPromoCodeApplied }) => {
  const location = useLocation();
  const { vehicleDetails } = location.state || {};
  const [isCoupon, setIsCoupon] = useState("");
  const [error, setError] = useState(null);
  const { sendRequest } = useRequest();

  const couponHandler = (e) => {
    setIsCoupon(e.target.value);
    setError(null);
  };

  const couponSubmitHandler = async (e) => {
    e.preventDefault();

    const couponTrimmed = (isCoupon || "").trim();

    if (couponTrimmed === "") {
      setError("Please enter a coupon code.");
      return;
    }

    const applyCodeData = new FormData();
    applyCodeData.append("promocode", couponTrimmed);
    applyCodeData.append("base_fare", vehicleDetails?.base_fare || 0);
    applyCodeData.append("tax_fare", vehicleDetails?.taxes_and_charges || 0);

    try {
      const response = await sendRequest({
        method: "POST",
        url: "/applyPromocode",
        body: applyCodeData,
      });

      console.log("API Response:", response); // 🧪 Debugging line

      if (response?.status === true) {
        const promo = response?.data?.promocode || couponTrimmed;
        const discount = response?.data?.discount_amount || 0;

        setPromoCodeApplied({
          status: true,
          promocode: promo,
          discount: discount,
        });

        Swal.fire({
          icon: "success",
          title: "Coupon code Applied",
          text: `You saved ₹${discount}`,
        });

        setError(null);
      } else {
        const msg = response?.message || "Invalid coupon code.";
        setError(msg);
        Swal.fire({
          icon: "error",
          title: "Invalid Promocode",
          text: msg,
        });
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again later.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
    }
  };

  return (
    <>
      <form
        onSubmit={couponSubmitHandler}
        className="confirm-section--payment-makeCoupons-cabHotDeals-form mt-4"
      >
        <div className="form-group confirm-section--payment-makeCoupons-cabHotDeals-form-input">
          <Input
            type="text"
            name="coupon"
            placeholder="eg. CAB100"
            value={isCoupon}
            onChange={couponHandler}
            className="form-control"
            id="couponCodeField"
            label="Enter Coupon code"
          />
        </div>

        <div className="form-group confirm-section--payment-makeCoupons-cabHotDeals-form-submit">
          <button type="submit" className="apply">
            APPLY
          </button>
        </div>
      </form>

      {error && (
        <div className="error-message" style={{ color: "red", marginTop: "10px" }}>
          {error}
        </div>
      )}
    </>
  );
};

export default CouponForm;
